module.exports = __webpack_public_path__ + "static/media/body.f63a0c15.svg";